import { render, staticRenderFns } from "./ToggleChatButton.vue?vue&type=template&id=fb8040ce&scoped=true&"
import script from "./ToggleChatButton.vue?vue&type=script&lang=js&"
export * from "./ToggleChatButton.vue?vue&type=script&lang=js&"
import style0 from "./ToggleChatButton.vue?vue&type=style&index=0&id=fb8040ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8040ce",
  null
  
)

export default component.exports